var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scroll-pane",
    [
      _c(
        "action-header",
        { attrs: { slot: "header" }, slot: "header" },
        [
          _c(
            "div",
            { staticClass: "search" },
            [
              _c("VueIcon", { attrs: { icon: "search" } }),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.filter,
                    expression: "filter",
                    modifiers: { trim: true }
                  }
                ],
                attrs: { placeholder: "Filter inspected state" },
                domProps: { value: _vm.filter },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.filter = $event.target.value.trim()
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              })
            ],
            1
          ),
          _c("VueTypeAhead", {
            attrs: {
              value: _vm.inspectedModule,
              suggestions: _vm.moduleSuggestions,
              "icon-right": "filter_list",
              placeholder: "(Root)",
              "show-all": "",
              "restrict-choice": ""
            },
            on: {
              update: function(value) {
                return _vm.setInspectedModule(value)
              }
            }
          }),
          _c(
            "a",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Export Vuex State",
                  expression: "'Export Vuex State'"
                }
              ],
              staticClass: "button export",
              on: { click: _vm.copyStateToClipboard }
            },
            [
              _c("VueIcon", { attrs: { icon: "content_copy" } }),
              _c("span", [_vm._v("Export")]),
              _c("transition", { attrs: { name: "slide-up" } }, [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showStateCopiedMessage,
                        expression: "showStateCopiedMessage"
                      }
                    ],
                    staticClass: "message"
                  },
                  [_vm._v("\n          (Copied to clipboard!)\n        ")]
                )
              ])
            ],
            1
          ),
          _c(
            "a",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Import Vuex State",
                  expression: "'Import Vuex State'"
                }
              ],
              staticClass: "button import",
              on: { click: _vm.toggleImportStatePopup }
            },
            [
              _c("VueIcon", { attrs: { icon: "content_paste" } }),
              _c("span", [_vm._v("Import")])
            ],
            1
          ),
          _c("transition", { attrs: { name: "slide-down" } }, [
            _vm.showImportStatePopup
              ? _c("div", { staticClass: "import-state" }, [
                  _c("textarea", {
                    attrs: {
                      placeholder: "Paste state object here to import it..."
                    },
                    on: {
                      input: _vm.importState,
                      keydown: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "esc", 27, $event.key, [
                            "Esc",
                            "Escape"
                          ])
                        ) {
                          return null
                        }
                        $event.stopPropagation()
                        return _vm.closeImportStatePopup($event)
                      }
                    }
                  }),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showBadJSONMessage,
                          expression: "showBadJSONMessage"
                        }
                      ],
                      staticClass: "message invalid-json"
                    },
                    [_vm._v("\n          INVALID JSON!\n        ")]
                  )
                ])
              : _vm._e()
          ])
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "vuex-state-inspector",
          class: {
            pointer: _vm.isOnlyMutationPayload
          },
          attrs: { slot: "scroll" },
          on: {
            click: function($event) {
              _vm.isOnlyMutationPayload && _vm.loadState()
            }
          },
          slot: "scroll"
        },
        [
          _c("state-inspector", {
            attrs: {
              state: _vm.filteredState,
              "dim-after": _vm.isOnlyMutationPayload ? 1 : -1
            }
          })
        ],
        1
      ),
      _vm.$shared.snapshotLoading
        ? _c(
            "div",
            {
              staticClass: "state-info loading-vuex-state",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("div", { staticClass: "label" }, [
                _vm._v("\n      Loading state...\n    ")
              ]),
              _c("VueLoadingIndicator")
            ],
            1
          )
        : _vm.isOnlyMutationPayload
        ? _c(
            "div",
            {
              staticClass: "state-info recording-vuex-state",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "div",
                { staticClass: "label" },
                [
                  _c("VueIcon", {
                    staticClass: "medium",
                    attrs: { icon: "cached" }
                  }),
                  _c("span", [_vm._v("Recording state on-demand...")]),
                  _vm.lastReceivedState
                    ? _c("span", { staticClass: "note" }, [
                        _vm._v("displaying last received state")
                      ])
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "VueButton",
                    {
                      staticClass: "accent flat",
                      attrs: {
                        "data-id": "load-vuex-state",
                        "icon-left": "arrow_forward"
                      },
                      on: {
                        click: function($event) {
                          return _vm.loadStateNow()
                        }
                      }
                    },
                    [_vm._v("\n        Load state\n      ")]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }